import React, {
  useCallback,
  useEffect, useMemo, useState,
} from 'react';
import { Form } from 'antd';
import moment from 'moment';
import { TCM } from 'components/tcm';
import { CHAR } from 'settings/namedUnicode';
import { connect } from 'react-redux';
import {
  tcmReportExport as tcmReportExportAction,
  tcmReportExportReset as tcmReportExportResetAction,
  saveReportTemplate as saveReportTemplateAction,
  saveReportTemplateReset as saveReportTemplateResetAction,
  getTcmReportSettings as getTcmReportSettingsAction,
  getTcmReportSettingsReset as getTcmReportSettingsResetAction,
} from 'redux/tcmReport/actions';
import {
  periodGetReport as periodGetReportAction,
  periodResetReport as periodResetReportAction,
} from 'redux/tcmPeriod/actions';

import { CreateErrorModal, CreateDraftSuccessfulModal } from 'components/tcm/Modals';

import { ModalWithChildren } from 'components/tcm/ClientInfo/style';
import { formatCampaignResponse } from 'tcm/campaigns/format';
import {
  ConversionBlock,
  ConversionCount, DescriptionBlockTitle, DescriptionText,
  DivisionCount,
  DivisionRow,
  DoubleFunnelItem,
  Equally,
  FunnelItem,
  Page,
  ReportDescription,
  ReportDescriptionBody,
  ReportDescriptionTitle,
  ModalText,
  FormItem,
  FiltersWrapper,
  PageTitle,
  BlockTitle,
  FormWrapper,
  DatePresets,
  DescriptionItem,
  ItemTitle,
  ItemContent,
  FunnelWrapper,
  FunnelTitle,
  Funnel,
  Header,
  ButtonsWrapper,
  NoResults,
} from './style';

import { formFields, DateRangePresets } from './data';

const initialValues = {
  [formFields.dateRange.key]: 'allTime',
  [formFields.dateFrom.key]: undefined,
  [formFields.dateTo.key]: moment(),
};

const halfAYearDate = moment().quarter() >= 3
  ? moment().startOf('year').add(6, 'M')
  : moment().startOf('year');

const PeriodReport = ({
  // report
  reportData,
  reportIsLoading,
  reportIsLoaded,
  // reportError,

  // redux
  exportReportData,
  exportReportIsLoading,
  exportReportIsLoaded,
  exportReportError,

  // reportTemplateData,
  reportTemplateIsLoading,
  reportTemplateIsLoaded,
  reportTemplateError,

  reportSettingsData,
  // reportSettingsIsLoading,
  reportSettingsIsLoaded,
  // reportSettingsError,

  // actions
  tcmReportExport,
  tcmReportExportReset,

  saveReportTemplate,
  saveReportTemplateReset,

  periodResetReport,
  periodGetReport,

  getTcmReportSettings,
  getTcmReportSettingsReset,
}) => {
  const [templateName, setTemplateName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [requestReportData, setRequestReportData] = useState(null);
  const [showReportsForm, setReportsShowForm] = useState(true);

  const [form] = Form.useForm();

  const { funnelSaleList, conversionList } = reportData;

  const disabledDatesTo = (current) => {
    const dateFrom = form.getFieldValue('dateFrom');
    return current && moment(dateFrom).isValid ? current < moment(dateFrom).endOf('day') : current < moment().endOf('day');
  };

  const totalCount = funnelSaleList ? funnelSaleList[0]?.items[0].count : null;

  const firstDialingDate = useMemo(() => (
    moment(reportSettingsData.firstDialingDate).isValid()
      ? moment(reportSettingsData.firstDialingDate)
      : undefined
  ), [reportSettingsData]);

  const onFormChange = useCallback(
    (field) => {
      const { value, name } = field[0] || {};
      const [fieldName] = name || [];
      if (fieldName === formFields.dateFrom.key && moment(value).isValid()) {
        form.setFieldsValue({
          [formFields.dateTo.key]: undefined,
        });
      }
    },
    [form],
  );

  const funnel = useMemo(() => {
    if (funnelSaleList) {
      return (
        funnelSaleList.map((step, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            {step.items.length === 1 && (
              <FunnelItem
                total={totalCount}
                value={step.items[0].count}
                text={step.items[0].label}
                isFinal={step.level === 8}
                withoutText={[6, 7, 8].includes(step.level)}
              />
            )}

            {step.items.length === 2 && (
              <DoubleFunnelItem
                total={totalCount}
                firstValue={step.items[0].count}
                firstText={step.items[0].label}
                secondaryText={step.items[1].label}
                secondaryValue={step.items[1].count}
              />
            )}
          </li>
        ))
      );
    }

    return [];
  }, [funnelSaleList, totalCount]);

  const onSubmit = (values) => {
    const {
      dateFrom,
      dateTo,
    } = values;

    const data = {
      startAt: dateFrom.format('YYYY-MM-DD'),
      finishAt: dateTo.format('YYYY-MM-DD'),
    };
    // TODO setData
    setRequestReportData(data);
    periodGetReport(data);
    setReportsShowForm(false);
  };

  const onReset = () => {
    form.setFieldsValue({
      [formFields.dateFrom.key]: undefined,
      [formFields.dateTo.key]: undefined,
      [formFields.dateRange.key]: '',
    });
  };

  const onDateRangeChange = (event) => {
    switch (event.target.value) {
      case DateRangePresets.month.value: {
        form.setFieldsValue({
          [formFields.dateFrom.key]: moment().startOf('month'),
          [formFields.dateTo.key]: moment(),
        });
        break;
      }
      case DateRangePresets.quarter.value: {
        form.setFieldsValue({
          [formFields.dateFrom.key]: moment().startOf('quarter'),
          [formFields.dateTo.key]: moment(),
        });
        break;
      }
      case DateRangePresets.halfAYear.value: {
        form.setFieldsValue({
          [formFields.dateFrom.key]: halfAYearDate,
          [formFields.dateTo.key]: moment(),
        });
        break;
      }
      case DateRangePresets.year.value: {
        form.setFieldsValue({
          [formFields.dateFrom.key]: moment().startOf('year'),
          [formFields.dateTo.key]: moment(),
        });
        break;
      }
      case DateRangePresets.allTime.value: {
        form.setFieldsValue({
          [formFields.dateFrom.key]: firstDialingDate,
          [formFields.dateTo.key]: moment(),
        });
        break;
      }

      default:
        console.error('onDateRangeChange: Incorrect value of date range: ', event.target.value);
    }
  };

  const clearCurrentDateRangePresets = () => {
    form.setFieldsValue({
      [formFields.dateRange.key]: '',
    });
  };

  const conversionData = conversionList?.[0] || {};
  const conversionDividend = conversionData.params?.[0].value;
  const conversionDivider = conversionData.params?.[1].value;
  const { conversion } = conversionData;

  useEffect(() => {
    if (exportReportIsLoaded) {
      const url = URL.createObjectURL(exportReportData);
      const shadowLink = document.createElement('a');
      shadowLink.href = url;
      shadowLink.download = 'Report.xlsx';
      shadowLink.click();
      tcmReportExportReset();
    }
  }, [exportReportData, exportReportIsLoaded, tcmReportExportReset]);

  useEffect(() => {
    if (reportTemplateIsLoaded) {
      setShowModal(false);
    }
  }, [reportTemplateIsLoaded]);

  useEffect(() => {
    if (!reportSettingsIsLoaded) {
      getTcmReportSettings();
    } else {
      form.setFieldsValue({
        [formFields.dateFrom.key]: firstDialingDate,
      });
    }
  }, [
    reportSettingsIsLoaded,
    form,
    reportSettingsData,
    getTcmReportSettings,
    firstDialingDate,
  ]);

  useEffect(() => () => {
    periodResetReport();
    getTcmReportSettingsReset();
  }, [periodResetReport, getTcmReportSettingsReset]);

  if (reportIsLoading) {
    return (
      <TCM.Loader text="Идет построение отчета..." />
    );
  }

  return (
    <Page>
      <Header>
        <PageTitle>Отчет</PageTitle>
        {requestReportData && !showReportsForm && (
          <TCM.ButtonOutline
            widthSize="fixed"
            onClick={() => tcmReportExport(requestReportData)}
            loading={exportReportIsLoading}
          >
            Выгрузить в Excel
          </TCM.ButtonOutline>
        )}
      </Header>

      <FiltersWrapper>
        <BlockTitle>По периодам</BlockTitle>
        <FormWrapper show={showReportsForm}>
          <Form
            form={form}
            onFinish={onSubmit}
            layout="vertical"
            name="clientFilter"
            initialValues={initialValues}
            validateTrigger="onSubmit"
            onFieldsChange={onFormChange}
          >

            <TCM.StaticDateRange
              propsLabelFrom={{
                name: formFields.dateFrom.key,
                label: formFields.dateFrom.label,
                validateTrigger: 'onBlur',
                rules: formFields.dateFrom.rules,
              }}
              propsInputFrom={{
                onChange: clearCurrentDateRangePresets,
                name: formFields.dateFrom.key,
              }}
              propsLabelTo={{
                name: formFields.dateTo.key,
                label: formFields.dateTo.label,
                validateTrigger: 'onBlur',
                rules: formFields.dateTo.rules,
              }}
              propsInputTo={{
                name: formFields.dateTo.key,
                disabledDate: disabledDatesTo,
                onChange: clearCurrentDateRangePresets,
              }}
            />

            <DatePresets>
              <TCM.Label noStyle name={formFields.dateRange.key}>
                <TCM.RadioTextGroup onChange={onDateRangeChange}>
                  <TCM.RadioBtnText value={DateRangePresets.allTime.value}>
                    {DateRangePresets.allTime.label}
                  </TCM.RadioBtnText>
                  <TCM.RadioBtnText value={DateRangePresets.year.value}>
                    {DateRangePresets.year.label}
                  </TCM.RadioBtnText>
                  <TCM.RadioBtnText value={DateRangePresets.halfAYear.value}>
                    {DateRangePresets.halfAYear.label}
                  </TCM.RadioBtnText>
                  <TCM.RadioBtnText value={DateRangePresets.quarter.value}>
                    {DateRangePresets.quarter.label}
                  </TCM.RadioBtnText>
                  <TCM.RadioBtnText value={DateRangePresets.month.value}>
                    {DateRangePresets.month.label}
                  </TCM.RadioBtnText>
                </TCM.RadioTextGroup>
              </TCM.Label>
            </DatePresets>

            <ButtonsWrapper>
              <TCM.ButtonGroup flexPosition="flex-start">

                <Form.Item shouldUpdate noStyle>
                  {() => (
                    <TCM.Button
                      htmlType="submit"
                      loading={reportIsLoading}
                      disabled={!(
                        form.getFieldValue(formFields.dateFrom.key)
                          && form.getFieldValue(formFields.dateTo.key)
                      )}
                    >
                      Построить отчет
                    </TCM.Button>
                  )}
                </Form.Item>

                <Form.Item noStyle>
                  <TCM.ButtonOutline onClick={onReset}>
                    Сбросить фильтры
                  </TCM.ButtonOutline>
                </Form.Item>
              </TCM.ButtonGroup>
            </ButtonsWrapper>
          </Form>
        </FormWrapper>

        {!showReportsForm && (
          <div>
            <DescriptionItem>
              <ItemTitle>Действие по периоду:</ItemTitle>
              <ItemContent>
                {moment(requestReportData.startAt).format('DD.MM')}
                {' — '}
                {moment(requestReportData.finishAt).format('DD.MM.YYYY')}
              </ItemContent>
            </DescriptionItem>

            <TCM.ButtonGroup flexPosition="flex-start">
              <TCM.Button onClick={() => setReportsShowForm(true)}>Изменить</TCM.Button>
              <TCM.ButtonOutline
                onClick={() => setShowModal(true)}
              >
                Сохранить шаблон
              </TCM.ButtonOutline>
            </TCM.ButtonGroup>
          </div>
        )}
      </FiltersWrapper>

      {
        reportIsLoaded && !showReportsForm && (
          funnel.length > 0 ? (
            <>
              <FunnelWrapper>
                <FunnelTitle>Воронка продаж</FunnelTitle>

                <Funnel>
                  {funnel}
                </Funnel>

                {Boolean(conversion) && (
                  <ConversionBlock>
                    <ConversionCount>
                      Конверсия
                      {CHAR.NBSP}
                      {`${Math.round(conversion * 100) / 100} %`}
                    </ConversionCount>
                    <Equally />
                    <div>
                      <DivisionRow>
                        <DivisionCount>{conversionDividend}</DivisionCount>
                        {CHAR.NBSP}
                        Клиентов взяли кредит
                      </DivisionRow>
                      <DivisionRow>
                        <DivisionCount>{conversionDivider}</DivisionCount>
                        {CHAR.NBSP}
                        Согласованных результатов звонка
                      </DivisionRow>
                    </div>
                  </ConversionBlock>
                )}

              </FunnelWrapper>

              <ReportDescription>
                <ReportDescriptionTitle>В воронку продаж включены:</ReportDescriptionTitle>
                <ReportDescriptionBody>
                  <div>
                    <DescriptionBlockTitle>Кампании:</DescriptionBlockTitle>
                    <div>
                      {formatCampaignResponse(reportData)?.map((campaign) => (
                        <DescriptionText>
                          {`${campaign.brand} ${campaign.model} (${campaign.dialingFrom} - ${campaign.dialingTo})`}
                        </DescriptionText>
                      ))}
                    </div>
                  </div>

                  <div>
                    <DescriptionBlockTitle>Сотрудники:</DescriptionBlockTitle>
                    <div>
                      {reportData.userList
                      && Array.isArray(reportData.userList)
                      && (reportData.userList.length > 0)
                        ? reportData.userList.map((item) => (
                          <DescriptionText>
                            {item.name}
                          </DescriptionText>
                        )) : (
                          <DescriptionText>&mdash;</DescriptionText>
                        )}
                    </div>
                  </div>
                </ReportDescriptionBody>
              </ReportDescription>
            </>
          )
            : (
              <NoResults>
                Информация не найдена. Попробуйте изменить данные для построения отчета
              </NoResults>
            )
        )

      }

      <ModalWithChildren
        visible={showModal}
        onOk={() => saveReportTemplate({
          reportType: 'campaign',
          name: templateName,
          params: { ...requestReportData },
        })}
        onClose={() => {
          setShowModal(false);
          setTemplateName('');
          saveReportTemplateReset();
        }}
        onCancel={
          () => {
            setShowModal(false);
            setTemplateName('');
            saveReportTemplateReset();
          }
        }
        title="Шаблон"
        btnTextOk="Сохранить"
        disabledOk={!templateName}
        onOkLoading={reportTemplateIsLoading}
        onOkError={reportTemplateError}
        btnTextCancel="Не сохранять"
      >
        <ModalText>
          Шаблон упрощает работу с отчетами.
          <br />
          Все параметры отчета будут сохранены, и вам не придется заново их выбирать.
        </ModalText>

        <FormItem label="Название шаблона">
          <TCM.Input
            placeholder="Укажите название"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </FormItem>

      </ModalWithChildren>

      <CreateErrorModal
        onCancel={() => {
          tcmReportExportReset();
        }}
        visible={Boolean(exportReportError)}
        title="Ошибка"
        description="Ошибка сервера выгрузка excel-файла невозможна, попробуйте позже"
      />

      <CreateDraftSuccessfulModal
        visible={reportTemplateIsLoaded}
        onCancel={() => {
          saveReportTemplateReset();
        }}
        title="Шаблон успешно сохранен"
      />
    </Page>
  );
};

export default connect(
  (state) => ({
    exportReportData: state.tcmReport.export.data,
    exportReportIsLoading: state.tcmReport.export.isLoading,
    exportReportIsLoaded: state.tcmReport.export.isLoaded,
    exportReportError: state.tcmReport.export.error,

    reportTemplateData: state.tcmReport.reportTemplate.data,
    reportTemplateIsLoading: state.tcmReport.reportTemplate.isLoading,
    reportTemplateIsLoaded: state.tcmReport.reportTemplate.isLoaded,
    reportTemplateError: state.tcmReport.reportTemplate.error,

    reportSettingsData: state.tcmReport.settings.data,
    reportSettingsIsLoading: state.tcmReport.settings.isLoading,
    reportSettingsIsLoaded: state.tcmReport.settings.isLoaded,
    reportSettingsError: state.tcmReport.settings.error,

    reportData: state.tcmPeriod.report.data,
    reportIsLoading: state.tcmPeriod.report.isLoading,
    reportIsLoaded: state.tcmPeriod.report.isLoaded,
    reportError: state.tcmPeriod.report.error,
  }),
  {
    tcmReportExport: tcmReportExportAction,
    tcmReportExportReset: tcmReportExportResetAction,
    saveReportTemplate: saveReportTemplateAction,
    saveReportTemplateReset: saveReportTemplateResetAction,
    getTcmReportSettings: getTcmReportSettingsAction,
    getTcmReportSettingsReset: getTcmReportSettingsResetAction,

    periodGetReport: periodGetReportAction,
    periodResetReport: periodResetReportAction,
  },
)(PeriodReport);
